<script lang="ts">
  import Header from './components/Header.svelte'
  import Footer from './components/Footer.svelte'
  import Loader from './pages/Loader.svelte';
  import { onMount } from 'svelte';
  import { isDemo } from './lib/stores/mode';
  import { route } from './lib/stores/route';
  import ErrorPage from './pages/Error.svelte';
  import CampaignOver from './pages/CampaignOver.svelte';
  import CampaignTeaser from './pages/CampaignTeaser.svelte';
  import Prizes from './pages/Prizes.svelte';
  import FAQ from './pages/FAQ.svelte';
  import Home from './pages/Homepage.svelte';
  import Register from './pages/Register.svelte';
  import Code from './pages/Code.svelte';
  import ThankYou from './pages/ThankYou.svelte';
  import VerifyModal from './components/VerifyModal.svelte';
  import CountrySelector from './pages/CountrySelector.svelte';
  import { restoreJwt, handleQueryParams, setupInitialPage, isProductionSite } from './lib/helpers/setup';

  const query = new URLSearchParams(document.location.search);

  restoreJwt();
  handleQueryParams();
  onMount(setupInitialPage); // TODO: Unsure if this should go on mount or not

  let gtmAuth = isProductionSite ? import.meta.env.FOOJI_GTM_AUTH as string : import.meta.env.FOOJI_DEV_GTM_AUTH as string;
  let gtmPreview = isProductionSite ? import.meta.env.FOOJI_GTM_PREVIEW as string : import.meta.env.FOOJI_DEV_GTM_PREVIEW as string;
  let consentCode = import.meta.env.FOOJI_CONSENT_CODE as string;

  // @ts-expect-error
  window.GTM = { AUTH: gtmAuth, PREVIEW: gtmPreview };

  $: isLoading = $route.isLoading || (query.has("loader") && query.has('demo'));
</script>

<svelte:head>
  {#if gtmAuth && gtmPreview}
    <!-- Google Tag Manager -->
    <script>
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=' + window.GTM.AUTH + '&gtm_preview=' + window.GTM.PREVIEW + '&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-P447MCB5');
    </script>
    <!-- End Google Tag Manager -->
  {/if}
  <!-- OneTrust Cookies Consent Notice start for littlecaesars.com -->
  <script type="text/javascript" src="https://cdn.cookielaw.org/consent/{consentCode}/OtAutoBlock.js" ></script>
  <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script={consentCode}></script>
  <script type="text/javascript">function OptanonWrapper() { }</script>
  <!-- OneTrust Cookies Consent Notice end for littlecaesars.com -->
</svelte:head>

<Header />
<VerifyModal />
<CountrySelector />
<!-- Loader goes over everything, never replacing any view -->
{#if isLoading}
  <Loader />
{/if}

<div class:hidden={isLoading} class="flex flex-col flex-1">
  {#if $route.page === "error"}
    <ErrorPage />
  {:else if $route.page === "campaign-over"}
    <CampaignOver />
  {:else if $route.page === "campaign-teaser"}
    <CampaignTeaser />
  {:else if $route.page === "prizes"}
    <Prizes />
  {:else if $route.page === "faq"}
    <FAQ />
  {:else if $route.page === "flow"}
    {#if $route.step === "home"}
      <Home />
    {:else if $route.step === "register"}
      <Register />
    {:else if $route.step === "code"}
      <Code />
    {:else if $route.step === "thank-you"}
      <ThankYou />
    {/if}
  {/if}
</div>
<Footer />
{#if isDemo()}
  <div class="w-full flex justify-center py-[1rem] text-3xl text-white bg-[red] opacity-0">DEMO</div>
  <div class="fixed bottom-0 w-full flex justify-center py-[1rem] text-3xl text-white bg-[red] z-[1000]">DEMO</div>
{/if}